module.exports = __webpack_public_path__ + "img/tit2.5843716a.png";